/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1AppsListAppsRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Maximum number of apps to return per request.
   *
   * @remarks
   * Balance between response size and number of pagination calls needed.
   */
  limit?: number | undefined;
  /**
   * Pagination cursor from a previous response to fetch the next page.
   *
   * @remarks
   * Use when `hasMore: true` in the previous response.
   */
  cursor?: string | undefined;
  /**
   * Free-form text to filter apps. Returns apps whose ID, name, or slug contains the search string. Matching is case-insensitive.
   */
  search?: string | undefined;
};

/** @internal */
export type V1AppsListAppsRequestBody$Outbound = {
  project: string;
  limit: number;
  cursor?: string | undefined;
  search?: string | undefined;
};

/** @internal */
export const V1AppsListAppsRequestBody$outboundSchema: z.ZodType<
  V1AppsListAppsRequestBody$Outbound,
  z.ZodTypeDef,
  V1AppsListAppsRequestBody
> = z.object({
  project: z.string(),
  limit: z.number().int().default(100),
  cursor: z.string().optional(),
  search: z.string().optional(),
});

export function v1AppsListAppsRequestBodyToJSON(
  v1AppsListAppsRequestBody: V1AppsListAppsRequestBody,
): string {
  return JSON.stringify(
    V1AppsListAppsRequestBody$outboundSchema.parse(v1AppsListAppsRequestBody),
  );
}
